import {
  IListLibraryMediaResponse,
  IMediaItem,
} from 'modules/media/interfaces/api';
import { useEffect, useMemo, useState } from 'react';
// import { useNavigate } from 'react-router-dom';

export interface BreadcrumbPath {
  label: string;
  path: string;
}

type MutateFn = (path: string, keySearch?: string) => void;

export const useGetMediaExploreInStore = (
  data: IListLibraryMediaResponse | null,
  mutate: MutateFn,
  initialPath = '',
  lazy = false,
) => {
  // const navigate = useNavigate();
  const [currentPath, setCurrentPath] = useState(initialPath);
  const [currentFolderName, setCurrentFolderName] = useState('');

  useEffect(() => {
    if (!lazy) {
      mutate(currentPath);
    }
  }, [currentPath, lazy]);

  const openFolder = (folder: IMediaItem) => {
    setCurrentPath(folder.path);
    setCurrentFolderName(folder.name);
  };

  const onBack = () => {
    if (currentPath === initialPath) {
    //   navigate(-1);
      return;
    }

    const segments = currentPath.split('/').filter(Boolean);

    const initialSegments = initialPath.split('/').filter(Boolean);

    if (segments.length <= initialSegments.length) {
    //   navigate(-1);
      return;
    }

    const parentPath = segments.slice(0, -1).join('/');

    setCurrentPath(parentPath);
    setCurrentFolderName(segments[segments.length - 2] || '');
  };

  const goRoot = () => {
    setCurrentPath(initialPath);
  };

  const breadcrumbItems = useMemo<BreadcrumbPath[]>(() => {
    if (currentPath === initialPath) {
      return [];
    }

    const segments = currentPath.split('/').filter(Boolean);

    const initialSegments = initialPath.split('/').filter(Boolean);

    // Chỉ hiển thị breadcrumb từ folder hiện tại trở xuống
    const relativeSegments = segments.slice(initialSegments.length);

    return relativeSegments.map((segment, index) => ({
      label: segment,
      path: segments.slice(0, initialSegments.length + index + 1).join('/'),
    }));
  }, [currentPath, initialPath]);

  const goToPath = (path: string) => {
    setCurrentPath(path);
  };

  return {
    items: data?.items ?? [],
    currentPath,
    pathStack: breadcrumbItems,
    openFolder,
    onBack,
    goRoot,
    goToPath,
    currentFolderName,
  };
};
